import { Select } from '@icecreamsocial/components';
import React from 'react';
import countries from './options';
import { useField } from 'formik';

export const CountryCodeSelect = ({ name, defaultCountry, ...rest }) => {
	const [field, meta, helpers] = useField(name);
	const defaultValue = getDefaultCountry(defaultCountry);

	return (
		<Select
			{...field}
			name={name}
			options={countries}
			defaultValue={defaultValue}
			components={{ Option, IndicatorSeparator }}
			onChange={(value) => {
				helpers.setValue(value);
			}}
			{...rest}
		/>
	);
};

const Option = ({ data, ...rest }) => {
	return (
		<Select.Components.Option {...rest}>
			{data.flag} {data.abbreviation} {data.dialCode}
		</Select.Components.Option>
	);
};

const IndicatorSeparator = () => null;

function getDefaultCountry(countryCode) {
	return countries.find(({ value }) => value === countryCode);
}
